export default (theme) => ({
    ...theme.softpro.tableColumns,
    input: {
        width: 175,
        maxWidth: 175,
    },
});
